export default {"src":"/_next/static/image/public/logos/kucoin-icon.65cd59a9da9785fb910202b57c79b2c2.svg","height":500,"width":800};